// GAVION team sessions: Reports → "Sessions" (/rapports/sessions), admins only.
export const sessionsEn = {
  title: "Sessions",
  description: "Who is dialing right now, and every dial session of the team.",
  error: "Could not load the sessions.",
  not_found: "This session cannot be found.",
  live: {
    title: "Live",
    none: "Nobody is in a session right now.",
    count: "%{smart_count} rep in session |||| %{smart_count} reps in session",
    since: "Since %{time}",
    paused: "Paused",
    active: "Active",
    current: "Current lead",
    no_current: "No open lead",
    auto_refresh: "Updates automatically.",
    open_session: "View session",
  },
  history: {
    title: "History",
    rep: "Rep",
    all_reps: "Whole team",
    count: "%{smart_count} session |||| %{smart_count} sessions",
    empty: "No session in this period.",
    start: "Start",
    end: "End",
    in_progress: "In progress",
    pagination: "History pages",
    previous: "Previous",
    next: "Next",
    page: "Page %{page} of %{pages}",
  },
  metrics: {
    duration: "Duration",
    dials: "Dials",
    conversations: "Conversations",
    demos: "Demos",
    dials_per_hour: "Dials / hour",
    talk_time: "Talk time",
    totals: "Period total",
  },
  detail: {
    title: "%{name}'s session",
    title_fallback: "Session",
    back: "Back to sessions",
    range: "%{start} → %{end}",
    live: "Session in progress",
    calls: "Session calls",
    calls_empty: "No call in this session.",
    time: "Time",
    lead: "Lead",
    contact: "Contact",
    outcome: "Outcome",
    talk: "Talk time",
    granola: "Granola note",
    granola_link: "Open the note",
    granola_page: "See in Meetings",
    open_call: "In progress",
    not_counted: "not counted",
  },
  dashboard: {
    title: "In session",
    none: "Nobody is in a session.",
    link: "View sessions",
  },
  rep_link: "View their sessions",
};
